import { useNavigate } from "react-router-dom";
import services from "../../Data/ServiceData";

const ServiceCompo = () => {
  const navigate = useNavigate();

  const handleViewMore = (id) => {
    navigate(`/service-details/${id}`);
  };

  return (
    <div className="p-6">
      <h1 className="text-3xl lg:text-4xl font-bold text-center my-12">
        Our Mehendi Services
      </h1>
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
        {services.slice(0, 6).map((service) => (
          <div
            key={service.id}
            className="w-full h-full border border-yellow-400 rounded-lg p-4 shadow-lg hover:shadow-2xl transition-shadow"
          >
            <img
              src={service.image}
              alt={service.name}
              className="w-full h-96 object-cover rounded-md mb-4"
            />
            <h2 className="text-xl text-yellow-400 font-semibold mb-2">
              {service.name}
            </h2>
            <p className="text-white mb-4">{service.shortDescription}</p>
            <button
              onClick={() => handleViewMore(service.id)}
              className="w-full bg-yellow-400 text-slate-900 px-4 py-2 rounded hover:bg-yellow-500 transition"
            >
              View More
            </button>
          </div>
        ))}
      </div>
    </div>
  );
};

export default ServiceCompo;
